// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import proposalSupporterEntity from './entities/proposal-supporter.json';
import proposalSupporterMenu from '../pages/proposal-supporter/menu.json';
import proposalSupporterFullForm from '../pages/proposal-supporter/forms/full.json';
import proposalSupporterContextForm from '../pages/proposal-supporter/forms/context.json';
import proposalSupporterMiniForm from '../pages/proposal-supporter/forms/mini.json';
import proposalSupporterLookupForm from '../pages/proposal-supporter/forms/lookup.json';
import proposalSupporterTableView from '../pages/proposal-supporter/views/table.json';
import proposalSupporterCardsView from '../pages/proposal-supporter/views/cards.json';
import proposalSupporterDashboardView from '../pages/proposal-supporter/views/dashboard.json';

/** Тип запису «Прихильник пропозиції» зі сторінками пакета: меню, форми та подання з pages/proposal-supporter/. */
export const proposalSupporterDefinition: IRecordTypeDefinition = {
  ...proposalSupporterEntity,
  views: assembleViewSet({
      table: proposalSupporterTableView,
      cards: proposalSupporterCardsView,
      dashboard: proposalSupporterDashboardView,
  }),
  form: proposalSupporterFullForm,
  forms: { full: proposalSupporterFullForm, context: proposalSupporterContextForm, mini: proposalSupporterMiniForm, lookup: proposalSupporterLookupForm },
  menu: proposalSupporterMenu,
} as IRecordTypeDefinition;
